import { indicatorsAxiosInstance } from 'api/config'

export const getIndicators = () => {
  return indicatorsAxiosInstance.get('Prod/api/indicators')
}

export { indicatorsAxiosInstance }
